export default function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_679_3102)">
        <path
          d="M15.04 8.16675C15.04 7.64675 14.9933 7.14675 14.9067 6.66675H8V9.50675H11.9467C11.7733 10.4201 11.2533 11.1934 10.4733 11.7134V13.5601H12.8533C14.24 12.2801 15.04 10.4001 15.04 8.16675Z"
          fill="#4285F4"
        />
        <path
          d="M8.00004 15.3332C9.98004 15.3332 11.64 14.6799 12.8534 13.5599L10.4734 11.7132C9.82004 12.1532 8.9867 12.4199 8.00004 12.4199C6.09337 12.4199 4.47337 11.1332 3.89337 9.3999H1.45337V11.2932C2.66004 13.6866 5.13337 15.3332 8.00004 15.3332Z"
          fill="#34A853"
        />
        <path
          d="M3.89329 9.39338C3.74663 8.95338 3.65996 8.48671 3.65996 8.00005C3.65996 7.51338 3.74663 7.04671 3.89329 6.60671V4.71338H1.45329C0.953293 5.70005 0.666626 6.81338 0.666626 8.00005C0.666626 9.18671 0.953293 10.3 1.45329 11.2867L3.35329 9.80671L3.89329 9.39338Z"
          fill="#FBBC05"
        />
        <path
          d="M8.00004 3.58675C9.08004 3.58675 10.04 3.96008 10.8067 4.68008L12.9067 2.58008C11.6334 1.39341 9.98004 0.666748 8.00004 0.666748C5.13337 0.666748 2.66004 2.31341 1.45337 4.71342L3.89337 6.60675C4.47337 4.87341 6.09337 3.58675 8.00004 3.58675Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_679_3102">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
